import React, {PropTypes} from 'react';
import '../../../styles/profile/profileHeader.css';
import * as paths from '../../../constants/pathConstants';
const ProfileHeading = ({onClick, activeTab}) => {
  return (
    <div id="profile-heading">
      <div className="row profile-tabs">
        <div className="col-sm-9 col-xs-12">
          <ul className="nav nav-tabs ">
            <li className={"profile-tab" + ((activeTab == "1" || activeTab == "2") ? " active" : "")}>
              <a name={paths.accountPageBase + paths.pathToAccountPage} 
                onClick={onClick}>Profile</a>
            </li>
            <li className={"api-tab" + ((activeTab == "3") ? " active" : "")}>
              <a name={paths.accountPageBase + paths.pathToApiTokenPage} 
                onClick={onClick}>API Token</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
ProfileHeading.propTypes = {
  user: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  activeTab: PropTypes.string.isRequired
};
export default ProfileHeading;



/** WEBPACK FOOTER **
 ** ./src/components/account/manageAccount/ProfileHeading.js
 **/